module.exports = require("acorn");